import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    padding: 0;\n    cursor: ", ";\n    color: ", ";\n    user-select: none;\n\n    :disabled {\n        color: red;\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    outline: 0 !important;\n    border: none !important;\n    box-shadow: unset !important;\n    padding: 0 !important;\n\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 0;\n    color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    width: fit-content;\n\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    width: ", ";\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { RawInput } from '..';
import { Icon } from '../Icon';
import { H3 } from '../Typography';
export var StyledWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.components.displayInput.width;
});
export var StyledControlsWrapper = styled.span(_templateObject2(), function (props) {
  return "\n        padding: ".concat(props.theme.components.displayInput.padding, ";\n        border-bottom: 1px solid ").concat(props.theme.global.colors.porcelainDarker, " !important;\n    ");
});
export var StyledLabel = styled(H3)(_templateObject3(), function (props) {
  return props.theme.global.colors.doveGrayLight;
});
export var StyledInput = styled(RawInput)(_templateObject4(), function (props) {
  return "\n        font: ".concat(props.theme.components.typography.config.headings.h2.font, ";\n        color: ").concat(props.theme.global.colors.primary, ";\n        text-align: center;\n    ");
});
export var StyledIcon = styled(Icon)(_templateObject5(), function (props) {
  return props.disabled ? 'initial' : 'pointer';
}, function (props) {
  return props.disabled ? props.theme.components.input.disabled : props.theme.global.colors.primary;
});